import axios from "axios";

interface Params {
    token: string;
    refreshToken: string;
    channelToken: string;
}

const setAuthToken = ({ token, refreshToken, channelToken }: Params) => {
    if (token) {
        axios.defaults.headers.common.Authorization = `Bearer ${ token }`;
        localStorage.setItem("access-token", token);
        localStorage.setItem("refresh-token", refreshToken);
    } else {
        delete axios.defaults.headers.common.Authorization;
        localStorage.setItem("access-token", "");
        localStorage.setItem("refresh-token", refreshToken);
    }

    if (channelToken) {
        localStorage.setItem("channel-access-token", channelToken);
    }else{
        localStorage.setItem("channel-access-token", "");
    }
};

export default setAuthToken;
